<template>
  <CCard>
    <CCardHeader>
      <h2>予定外時間外報告詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="container">
          <table class="table">
            <tr>
              <th scope="row">申請日</th>
              <td class="preika-report-detail-date">{{ updated_at }}</td>
            </tr>
            <tr>
              <th scope="row">予定時間外勤務時間</th>
              <td class="preika-report-detail-duration">{{ overtime }}時間</td>
            </tr>
            <tr>
              <th scope="row">発生理由</th>
              <td class="preika-report-detail-reason">{{ reason }}</td>
            </tr>
          </table>
          <CRow class="mt-3 align-items-center">
            <CCol class="text-start">
              <router-link :to="{ name: overTimesList }">
                <button class="btn btn-secondary">戻る</button>
              </router-link>
            </CCol>
            <CCol class="text-center">
              <router-link :to="{ name: overTimesEdit, params: { id: $route.params.id } }">
                <button class="btn btn-info">編集</button>
              </router-link>
            </CCol>
            <CCol></CCol>
          </CRow>
        </div>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from 'axios'
import ConstList from './../../ConstList'
import { safeErrorDigest } from '../../utils/safeResponseMessage'

export default {
  name: 'Info',
  data () {
    return {
      overtime: 0,
      updated_at: '',
      reason: '',
      errors: [],
      overTimesList: ConstList.ROUTE_OVERTIMES_LIST,
      overTimesEdit: ConstList.ROUTE_OVERTIMES_EDIT
    }
  },
  mounted () {
    const id = Number(this.$route.params.id)
    if (!Number.isSafeInteger(id) || id <= 0) {
      this.errors.push('予定外時間外報告を特定できません。')
      return
    }
    axios
      .get(`${process.env.VUE_APP_API_ORIGIN}/overtime/${id}`)
      .then(response => {
        if (!response.data) {
          this.errors.push(ConstList.EMPTY)
          return
        }
        const overtimeData = response.data
        this.overtime = overtimeData.overtime
        this.updated_at = overtimeData.updated_at
        this.reason = overtimeData.reason
      })
      .catch(error => {
        console.error('予定外時間外報告詳細取得失敗:', safeErrorDigest(error))
        alert(ConstList.SYSTEM_ERROR)
      })
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
</style>
